// @flow

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

import type { MessagesState } from './state'

export const mutations = {
  increaseUnreadMessagesCount (state: MessagesState, count: number): void {
    state.unreadMessagesCount += count
  },
  resetUnreadMessagesCount (state: MessagesState): void {
    state.unreadMessagesCount = 0
  },
  disableAutoScroll (state: MessagesState): void {
    state.autoScroll = false
  },
  enableAutoScroll (state: MessagesState): void {
    state.autoScroll = true
  },
  setMessages (state: MessagesState, messages: Array<ChatBubbleMessage<any>>): void {
    state.messages = messages
  },
  setCustomerSupport (state: MessagesState, customerSupport: string): void {
    state.customerSupport = customerSupport
  },
  setTypingIndicator (state: MessagesState, typingIndicator: boolean): void {
    state.isShowingTypingIndicator = typingIndicator
  },
  setLastMessageReceived (state: MessagesState, timestamp: ?Date): void {
    state.lastMessageReceived = timestamp
  },
  setMoreProductsClicked (state: MessagesState, value: boolean): void {
    state.moreProductsClicked = value
  }
}
